import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-drag",
  "use": "icon-drag-usage",
  "viewBox": "0 0 1194 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1194 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-drag\"><defs><style></style></defs><path d=\"M0 0h1194.667v170.667H0zm0 426.667h1194.667v170.666H0zm0 426.666h1194.667V1024H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol